import { getNotificationServiceApi } from '@tempo-io/nexus-client';
import type { KyInstance } from 'ky';
import { tempoApi } from '@/common/api/tempoApi';
import { getEnv } from '@/common/utils/getEnv';

export const getNotificationApi = ({
  client = tempoApi({ usePrefix: false }),
}: {
  client?: KyInstance;
} = {}) => getNotificationServiceApi({ client, prefixUrl: getEnv().apiBaseUrl });
